import { Component, OnDestroy, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LoginLayoutComponent } from 'projects/login/src/app/layout/login-layout/login-layout.component';
import { AuthService } from 'projects/login/src/app/services/auth/auth.service';

@Component({
  selector: 'pay-lost-mfa',
  imports: [FormsModule, TranslateModule],
  templateUrl: './lost-mfa.component.html',
})
export class LostMfaComponent implements OnDestroy {
  private readonly _router = inject(Router);
  private readonly _auth = inject(AuthService);

  code: string | undefined;
  oldHeaderText = LoginLayoutComponent.headerText();

  constructor() {
    const _auth = this._auth;
    const translate = inject(TranslateService);

    LoginLayoutComponent.headerText.set(translate.instant('lost-2fa.header.name'));
    this.code = _auth.supportCode;

    if (this.code === undefined || this.code === null || this.code === '') {
      this.returnToLogin();
    }

    this.code = this.code?.replace('-', ' - ');
  }

  ngOnDestroy(): void {
    LoginLayoutComponent.headerText.set(this.oldHeaderText);
  }

  returnToLogin() {
    this._router.navigateByUrl('/').then();
  }
}
